<template>
  <v-container class="pa-0" fluid>
    <el-overlay-loading :loading="pageloading" />
    <h1 class="mb-1">{{ $t('Papildomi paslaugų laukai') }}</h1>
    <el-button
      class="mb-5"
      color="primary"
      icon="pridėti"
      title="Pridėti naują"
      :loading="loading"
      @click.native.stop="newItem()"
    />
    <v-data-table
      class="mb-4 custom-table sticky-header"
      :loading="loading || paginationloading"
      :headers="filteredHeader"
      :items="filterItemList"
      :hide-default-footer="hideFooter"
      :header-props="{
        sortByText: $t('Rūšiuoti pagal'),
      }"
      :footer-props="{
        showFirstLastPage: true,
        showCurrentPage: true,
        itemsPerPageText: $t('Rodyti po:'),
        itemsPerPageAllText: $t('visi'),
        itemsPerPageOptions: itemsPerPageOptions,
      }"
      :sort-by.sync="pagination.sort"
      :sort-desc.sync="pagination.sortDesc"
      :server-items-length="pagination.total"
      :items-per-page="pagination.pageSize"
      :page.sync="pagination.page"
      @update:options="updatePagination"
    >
      <template #[`item.actions`]="{ item }">
        <div class="nowrap">
          <el-table-action
            :item="item"
            @editItem="editItem(item)"
            @deleteItem="deleteItem(item)"
          />
        </div>
      </template>
      <template #[`item.description`]="{ item }">
        <span class="description-cell">{{ item.description }}</span>
      </template>
      <template slot="loading"> {{ $t('Kraunasi...') }} </template>
      <template slot="no-results"> {{ $t('Duomenų nėra') }} </template>
      <template slot="no-data"> {{ $t('Duomenų nėra') }} </template>
      <template #[`footer.page-text`]="props">
        {{ $t('Rodoma') }} {{ props.pageStart }}-{{ props.pageStop }}
        {{ $t('iš') }}
        {{ props.itemsLength }}
      </template>
    </v-data-table>
    <modal-delete
      title="Šalinti įrašą"
      text="Ar tikrai norite pašalinti įrašą?"
      v-model="showDelete"
      :loading="loading"
      :item="modalDeleteItem"
      @confirmDelete="confirmDelete"
    />
  </v-container>
</template>

<script>
import userRole from '@/mixins/userRole'
import ModalDelete from '@/components/modals/ModalDelete'
import tableParameters from '@/mixins/tableParameters'

export default {
  name: 'ServiceExtraFields',
  components: {
    ModalDelete,
  },
  mixins: [userRole, tableParameters],
  data() {
    return {
      pageloading: true,
      loading: true,
      paginationloading: false,
      showDelete: false,
      modalDeleteItem: null,
      listData: [],
      searchData: {},
      itemsPerPageOptions: [10, 50, 100],
      pagination: {
        page: 1,
        pageSize: 100,
        total: 0,
        totalPages: 0,
        sort: null,
        sortDesc: [],
        direction: 'asc',
      },
    }
  },
  computed: {
    headers() {
      return [
        {
          text: this.$t('Veiksmai'),
          align: 'center',
          sortable: false,
          value: 'actions',
          width: '8rem',
        },
        {
          text: this.$t('Kodas'),
          align: 'start',
          value: 'code',
          width: '10rem',
        },
        {
          text: this.$t('Pavadinimas'),
          align: 'start',
          value: 'title',
        },
        {
          text: this.$t('Aprašymas'),
          align: 'start',
          value: 'description',
          sortable: false,
        },
      ]
    },
    filteredHeader() {
      return this.headers.filter((item) => !item.hide)
    },
    filterItemList() {
      return this.listData
    },
    hideFooter() {
      return this.pagination.total <= 10
    },
  },
  methods: {
    mapRowFlags(item) {
      return {
        ...item,
        canEdit: true,
        canDelete: true,
      }
    },
    extractSets(res) {
      const d = res.data || {}
      return (
        d.action_extra_field_sets ||
        d.actionExtraFieldSets ||
        d.sets ||
        []
      )
    },
    newItem() {
      this.$router.push({
        name: 'adminActionExtraFieldSetForm',
      })
    },
    editItem(item) {
      this.$router.push({
        name: 'adminActionExtraFieldSetForm',
        params: { id: String(item.id) },
      })
    },
    deleteItem(item) {
      this.modalDeleteItem = { ...item }
      this.showDelete = true
    },
    getData(resetPageNr = false) {
      if (resetPageNr) {
        this.pagination.page = 1
      }
      this.setSortParams()
      const data = {
        ...this.pagination,
        search: this.searchData,
      }
      this.$axios
        .post(`action-extra-field-sets/list`, data)
        .then((res) => {
          const rows = this.extractSets(res)
          this.listData = rows.map((r) => this.mapRowFlags(r))
          if (res.data.pagination) {
            this.pagination = { ...this.pagination, ...res.data.pagination }
          } else {
            this.pagination.total = rows.length
          }
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.pageloading = false
          this.paginationloading = false
        })
    },
    updatePagination(pagination) {
      if (this.paginationloading) {
        return
      }
      this.$store.dispatch('listParams', {
        pageSize: pagination.itemsPerPage,
        page: pagination.page,
        route: this.$route.name,
      })
      this.paginationloading = true
      this.pagination.page = pagination.page
      this.pagination.pageSize = pagination.itemsPerPage
      this.pagination.sort = pagination.sortBy[0]
      this.pagination.sortDesc = pagination.sortDesc
      this.pagination.direction = pagination.sortDesc[0] ? 'desc' : 'asc'
      if (!this.loading) {
        this.getData()
      }
    },
    confirmDelete(item) {
      this.loading = true
      this.$axios
        .delete(`action-extra-field-sets/${item.id}`)
        .then(() => {
          this.$root.$emit('DATA_OK_CODE', '000111')
          this.getData()
        })
        .catch((err) => {
          this.$root.$emit('DATA_ERROR', err)
        })
        .finally(() => {
          this.loading = false
          this.showDelete = false
        })
    },
  },
  mounted() {
    this.getData()
  },
}
</script>

<style lang="scss" scoped>
.description-cell {
  display: inline-block;
  max-width: 28rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  vertical-align: bottom;
}
</style>
